__turbopack_context__.v({
  "container": "FileUploader-module__8gzCXq__container",
  "dragging": "FileUploader-module__8gzCXq__dragging",
  "dropZone": "FileUploader-module__8gzCXq__dropZone",
  "fileIcon": "FileUploader-module__8gzCXq__fileIcon",
  "fileInfo": "FileUploader-module__8gzCXq__fileInfo",
  "fileName": "FileUploader-module__8gzCXq__fileName",
  "filePreview": "FileUploader-module__8gzCXq__filePreview",
  "fileSize": "FileUploader-module__8gzCXq__fileSize",
  "iconWrapper": "FileUploader-module__8gzCXq__iconWrapper",
  "removeBtn": "FileUploader-module__8gzCXq__removeBtn",
});
